export default {
  'menu.account': 'Conta',
  'menu.account.center': 'Perfil',
  'menu.dashboard': 'Painel',
  'menu.devices': 'Dispositivos',
  'menu.devices.list': 'Lista de Dispositivos',
  'menu.addressBook': 'Catálogos de Endereços',
  'menu.addressBook.personal': 'Pessoal',
  'menu.addressBook.shared': 'Compartilhado',
  'menu.deviceGroups': 'Grupos de Dispositivos',
  'menu.deviceGroups.list': 'Grupos de Dispositivos',
  'menu.users': 'Usuários',
  'menu.audits': 'Logs de Auditoria',
  'menu.audits.conn': 'Conexão',
  'menu.audits.file': 'Transferência de Arquivos',
  'menu.audits.alarm': 'Alarme',
  'menu.audits.console': 'Console',
  'menu.login': 'Entrar',
  'menu.roles': 'Funções',
  'menu.strategies': 'Estratégias',
  'menu.groups': 'Grupos',
  'menu.groups.user': 'Grupos de Usuários',
  'menu.groups.device': 'Grupos de Dispositivos',
  'menu.settings': 'Configurações',
  'menu.settings.general': 'Configurações Gerais',
  'menu.settings.smtp': 'Configuração SMTP',
  'menu.settings.oidcProviders': 'Provedores OIDC',
  'menu.settings.ldap': 'Configuração LDAP',
  'menu.customClients': 'Clientes Personalizados',
  'menu.addressBooks': 'Catálogos de Endereços',
  'menu.list.audit-list': 'Lista de Auditoria',
  'menu.list.audit-list.File': 'Transferência de Arquivos',
  'menu.list.audit-list.Connection': 'Conexão',
  'menu.list.audit-list.Alarm': 'Alarme',
};
